module.exports = __webpack_public_path__ + "images/ds-pre-footer-projects.webp";